//import http from 'hub-http/clients/apiClient';
import { http } from '../http';
import HubHttpClient from 'ExportDialog/apiClients/HubHttpBaseClient';
import { TEAM_API } from '../team';
import { ASSIGNMENTS_API } from '../playlistAssignments';
export const ExportClient = (exportType, extraData = {}) => {
  return Object.assign({}, HubHttpClient, {
    export: settings => {
      let endpoint;

      switch (exportType) {
        case 'MY_TEAM':
          {
            endpoint = `${TEAM_API}/export`;
            break;
          }

        case 'PLAYLIST_ASSIGNMENTS':
          {
            // TODO: export endpoint
            endpoint = `${ASSIGNMENTS_API}/export`;
            break;
          }

        default:
          return null;
      }

      return http.post(endpoint, {
        data: Object.assign({}, extraData, {}, settings)
      });
    }
  });
};